import './index.less';
import * as React from 'react';
import classnames from 'classnames';
import BottomFixed, { BottomSize } from '../BottomFixed';
import Header from './Header';
import Card from './Card';

export interface CardPageProps extends React.HTMLAttributes<HTMLDivElement> {
  prefixCls?: string;
  className?: string;
  /** 底部操作栏的大小, 同时用来判断是否存在底部操作栏 */
  bottomSize?: BottomSize;
  /** 是否有头部：比如过滤器，按钮等 */
  hasHeader?: boolean;
}

class CardPage extends React.Component<CardPageProps, any> {
  public static Header = Header;
  public static Card = Card;
  public static Bottom = BottomFixed;
  constructor(props: CardPageProps) {
    super(props);
  }

  public render() {
    const {
      prefixCls = 'mpc', bottomSize,
      hasHeader, children, className, ...others
    } = this.props;
    const classes = classnames({
      [`${prefixCls}-card-page`]: true,
      [`${prefixCls}-card-page-with-bottom-${bottomSize}`]: bottomSize,
      [`${prefixCls}-card-page-with-header`]: hasHeader,
    }, className);
    return (
      <div {...others} className={classes}>
        {children}
      </div>
    );
  }
}

export default CardPage;
